import Apollo from '@adoratorio/apollo';

import aion from './aion';

const apollo = {
  ref: null,
  init: () => {
    apollo.ref = new Apollo({
      mode: Apollo.FOLLOW.CURSOR,
      cursor: document.querySelector('.apollo'),
      type: Apollo.TYPE.HTML,
      easing: {
        mode: Apollo.EASING.OUT_CUBIC,
        duration: 400,
      },
      targets: [],
      detectTouch: true,
      aion,
      emitGlobal: true,
    });
  },
};

export default apollo;
